if (!customElements.get('product-info')) {
  customElements.define(
    'product-info',
    class ProductInfo extends HTMLElement {
      constructor() {
        super();
        this._initialized = false;
        this._fetchInProgress = false;
        this._abortController = null;
      }

      connectedCallback() {
        // ✅ Prevent duplicate init
        if (this._initialized) return;
        this._initialized = true;

        this.input = this.querySelector('.quantity__input');
        this.currentVariant = this.querySelector('.product-variant-id');
        this.submitButton = this.querySelector('[type="submit"]');
        this.quantityForm = this.querySelector('.product-form__quantity');

        if (!this.input || !this.quantityForm) return;

        this.setQuantityBoundries();

        if (!this.dataset.originalSection) {
          this.cartUpdateUnsubscriber = subscribe(
            PUB_SUB_EVENTS.cartUpdate,
            this.fetchQuantityRules.bind(this)
          );
        }

        this.variantChangeUnsubscriber = subscribe(
          PUB_SUB_EVENTS.variantChange,
          (event) => {
            const sectionId = this.dataset.originalSection || this.dataset.section;
            if (event?.data?.sectionId !== sectionId) return;

            this.updateQuantityRules(sectionId, event.data.html);
            this.setQuantityBoundries();
          }
        );
      }

      disconnectedCallback() {
        this.cartUpdateUnsubscriber?.();
        this.variantChangeUnsubscriber?.();

        // ✅ Abort in-flight request
        if (this._abortController) {
          this._abortController.abort();
        }
      }

      setQuantityBoundries() {
        if (!this.input) return;

        const data = {
          cartQuantity: parseInt(this.input.dataset.cartQuantity || 0),
          min: parseInt(this.input.dataset.min || 1),
          max: this.input.dataset.max ? parseInt(this.input.dataset.max) : null,
          step: parseInt(this.input.step || 1),
        };

        let min = data.min;
        const max = data.max === null ? null : data.max - data.cartQuantity;

        if (max !== null) min = Math.min(min, max);
        if (data.cartQuantity >= data.min) min = Math.min(min, data.step);

        this.input.min = min;
        this.input.max = max;
        this.input.value = min;

        publish(PUB_SUB_EVENTS.quantityUpdate, undefined);
      }

      fetchQuantityRules() {
        if (!this.currentVariant?.value) return;

        // ✅ cancel previous request
        if (this._abortController) {
          this._abortController.abort();
        }

        this._abortController = new AbortController();

        const url = `${this.dataset.url}?variant=${this.currentVariant.value}&section_id=${this.dataset.section}`;

        const spinner = this.querySelector('.loading__spinner');
        spinner?.classList.remove('hidden');

        fetch(url, { signal: this._abortController.signal })
          .then((res) => {
            if (!res.ok) throw new Error('Network error');
            return res.text();
          })
          .then((responseText) => {
            const html = new DOMParser().parseFromString(responseText, 'text/html');

            const updatedSection = html.getElementById(
              `Quantity-Form-${this.dataset.section}`
            );

            if (!updatedSection) {
              console.warn('Missing section in response');
              return;
            }

            this.updateQuantityRules(this.dataset.section, html);
            this.setQuantityBoundries();
          })
          .catch((e) => {
            if (e.name !== 'AbortError') {
              console.error('Fetch failed:', e);
            }
          })
          .finally(() => {
            spinner?.classList.add('hidden');
          });
      }

      updateQuantityRules(sectionId, html) {
        const quantityFormUpdated = html.getElementById(`Quantity-Form-${sectionId}`);
        if (!quantityFormUpdated || !this.quantityForm) return;

        const selectors = ['.quantity__input', '.quantity__rules', '.quantity__label'];

        for (let selector of selectors) {
          const current = this.quantityForm.querySelector(selector);
          const updated = quantityFormUpdated.querySelector(selector);

          if (!current || !updated) continue;

          if (selector === '.quantity__input') {
            const attrs = ['data-cart-quantity', 'data-min', 'data-max', 'step'];

            for (let attr of attrs) {
              const val = updated.getAttribute(attr);
              if (val !== null) current.setAttribute(attr, val);
            }
          } else {
            current.innerHTML = updated.innerHTML;
          }
        }
      }
    }
  );
}